import { render, staticRenderFns } from "./damage.vue?vue&type=template&id=17a86887&scoped=true"
import script from "./damage.vue?vue&type=script&lang=js"
export * from "./damage.vue?vue&type=script&lang=js"
import style0 from "./damage.vue?vue&type=style&index=0&id=17a86887&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a86887",
  null
  
)

export default component.exports